import s from "./loading.css";

export const styles = s;

export default `<div class="${s["loading"]}">LOADING<span>...</span></div>`;
